import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import RemoteImageSplashListContainer from '../../../containers/remoteImage/splash/RemoteImageSplashListContainer';
import { REMOTE_SPLASH_IMAGE_PAGE_NAME } from '../../../constants/service/app/remoteImageConstants';

const RemoteImageSplashList = () => {
  return (
    <PageTemplate pageName={REMOTE_SPLASH_IMAGE_PAGE_NAME.REMOTE_SPLASH_IMAGE_LIST}>
      <RemoteImageSplashListContainer />
    </PageTemplate>
  );
};

export default RemoteImageSplashList;
